/// <amd-module name="Core/Medius.Core.Web/Scripts/components/topBar/drawer/constants"/>
export const expenseManagement = "Expense management";